const fullgridmd = {
    numColumns: 2,
    numRows: 8,
    // number of slides specified in grid, also slide index of first view more slide
    slidesCovered: 10,
    moreSize: 12,
    borderWidth: 15,
    extraRows: 0, // generated by view more actions
    cellInstances: null, // generated by loader
    cells: {
        // image order as returned are keys
        1: {
            imageNum:0,
            col: 0,
            row: 0,
            size: 2,
            class: 'featured featured-1',
        },
        2: {
            imageNum: 1,
            col: 0,
            row: 2,
            size: 1,
        },
        3: {
            imageNum: 2,
            col: 1,
            row: 2,
            size: 1,
        },
        4: {
            imageNum: 3,
            col: 0,
            row: 3,
            size: 2,
            class: 'featured featured-2',
        },
        5: {
            imageNum: 4,
            col: 0,
            row: 5,
            size: 1,
        },
        6: {
            imageNum: 5,
            col: 1,
            row: 5,
            size: 1,
        },
        7: {
            imageNum: 6,
            col: 0,
            row: 6,
            size: 1,
        },
        8: {
            imageNum: 7,
            col: 1,
            row: 6,
            size: 1,
        },
        9: {
            imageNum: 8,
            col: 0,
            row: 7,
            size: 1,
        },
        10: {
            imageNum: 9,
            col: 1,
            row: 7,
            size: 1,
        },
    }
}

export default fullgridmd;
